import React from "react";
import "./ChatHeader.css";

const ChatHeader = ({
  title,
  logoUrl,
  isConnected,
  isMinimized,
  onMinimize,
  onMaximize,
  onClose,
  config,
  currentTheme,
  onToggleTheme,
}) => {
  // Debug logo URL
  console.log("ChatHeader - logoUrl:", logoUrl);
  console.log("ChatHeader - config.logoUrl:", config?.logoUrl);

  // Use logoUrl from config if direct logoUrl is not provided
  const actualLogoUrl = logoUrl || config?.logoUrl;
  console.log("ChatHeader - actualLogoUrl:", actualLogoUrl);

  return (
    <div className="chatbot-header">
      <div className="chatbot-header-left">
        {actualLogoUrl && (
          <div className="chatbot-logo">
            <img
              src={actualLogoUrl}
              alt="Logo"
              crossOrigin="anonymous"
              onLoad={() =>
                console.log("✅ Logo loaded successfully:", actualLogoUrl)
              }
              onError={(e) =>
                console.error("❌ Logo failed to load:", actualLogoUrl, e)
              }
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
        )}
        <div className="chatbot-header-info">
          <h3 className="chatbot-title">{title}</h3>
          <div className="chatbot-status">
            <div
              className={`chatbot-status-indicator ${
                isConnected ? "connected" : "disconnected"
              }`}
            ></div>
            <span className="chatbot-status-text">
              {isConnected ? "Online" : "Offline"}
            </span>
          </div>
        </div>
      </div>

      <div className="chatbot-header-actions">
        {config.showThemeToggler && (
          <button
            className="chatbot-header-button"
            onClick={onToggleTheme}
            aria-label={`Switch to ${
              currentTheme === "light" ? "dark" : "light"
            } theme`}
            type="button"
          >
            {currentTheme === "light" ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="5"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="12"
                  y1="1"
                  x2="12"
                  y2="3"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="12"
                  y1="21"
                  x2="12"
                  y2="23"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="4.22"
                  y1="4.22"
                  x2="5.64"
                  y2="5.64"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="18.36"
                  y1="18.36"
                  x2="19.78"
                  y2="19.78"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="1"
                  y1="12"
                  x2="3"
                  y2="12"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="21"
                  y1="12"
                  x2="23"
                  y2="12"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="4.22"
                  y1="19.78"
                  x2="5.64"
                  y2="18.36"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <line
                  x1="18.36"
                  y1="5.64"
                  x2="19.78"
                  y2="4.22"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            )}
          </button>
        )}

        <button
          className="chatbot-header-button"
          onClick={isMinimized ? onMaximize : onMinimize}
          aria-label={isMinimized ? "Maximize" : "Minimize"}
          type="button"
        >
          {isMinimized ? (
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 3V5M16 3V5M3 8H5M3 16H5M8 21V19M16 21V19M19 8H21M19 16H21"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 3V5M16 3V5M3 8H5M3 16H5M8 21V19M16 21V19M19 8H21M19 16H21"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </button>

        <button
          className="chatbot-header-button"
          onClick={onClose}
          aria-label="Close chat"
          type="button"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
